module.exports = __webpack_public_path__ + "img/bg-scenarios.cb9fd587.jpg";